import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

const PosCollectionTotalCurrentMonth = () => {
  const [widgetData, setWidgetData] = useState({
    loading: true,
  });

  useEffect(() => getData(), []);

  const getData = () => {
    RequestHandler.get("/B2BDashboard/CollectionTotalCurrentMonth").then((response) => {
      setWidgetData({
        data: response.data,
        loading: false,
      });
    });
  };

  return (
    <Widgets
      icon="calendar"
      currency={`01-${moment().format('DD MMMM')}`}
      title="Tahsilat Toplamı"
      totalBalance={
        <CurrencyFormat
          value={widgetData.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={"₺"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      }
    />
  );
};

export default PosCollectionTotalCurrentMonth;
